import { useMemo } from 'react';
import { useIsRevenueCatAvailable } from './useIsRevenueCatAvailable';
import { isInCapacitorPlatform } from '@fabric-app/compat/capabilities/platform';
import type { Store } from '@fabric-app/types/pricing/pricing.types';

export const useCurrentDeviceStore = () => {
  const isRevenueCatAvailable = useIsRevenueCatAvailable();

  return useMemo<Store>(() => {
    if (!isRevenueCatAvailable) {
      return 'stripe';
    }

    return isInCapacitorPlatform('capacitor-ios') ? 'app_store' : 'play_store';
  }, [isRevenueCatAvailable]);
};
